export default [
  {
    name: "Waffle Bath Bundle",
    description:
      "Turn your bathroom into the modern sanctuary of your dreams with our fully customizable Waffle Bath Bundle. Luxurious to the touch, ultra-absorbent, and ideal for stepping out of the shower, this bundle includes 2 Waffle Bath Towels, 2 Waffle Hand Towels, and 4 Waffle Wash Cloths, all from our Waffle Bath Collection. Made from 40% Premium Viscose from Bamboo fabric and 60% Cotton, this unique blend is extremely soft for spa-like comfort.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/waffleBathBundle.jpg?v=1660240146",
    products: [
      {
        handle: "waffle-bath-towels",
        quantity: 1,
      },

      {
        handle: "waffle-hand-towels",
        quantity: 1,
      },

      {
        handle: "waffle-washcloths",
        quantity: 1,
      },
    ],
  },
  {
    name: "Waffle Bath Deluxe Bundle",
    description:
      "Turn your bathroom into the modern sanctuary of your dreams with our fully customizable Waffle Bath Bundle. Luxurious to the touch, ultra-absorbent, and ideal for stepping out of the shower, this bundle includes 4 Waffle Bath Towels, 4 Waffle Hand Towels, and 4 Waffle Wash Cloths, all from our Waffle Bath Collection. Made from 40% Premium Viscose from Bamboo fabric and 60% Cotton, this unique blend is extremely soft for spa-like comfort.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/Squareshot-Waffle-BigBundle-White.jpg?v=1660259613",
    products: [
      {
        handle: "waffle-bath-towels",
        quantity: 2,
      },

      {
        handle: "waffle-hand-towels",
        quantity: 2,
      },

      {
        handle: "waffle-washcloths",
        quantity: 1,
      },
    ],
  },
  {
    name: "Premium Plush Bundle",
    description:
      "Turn your bathroom into the sanctuary of your dreams with our fully customizable Premium Plush Bundle. Luxurious to the touch, ultra-absorbent, and ideal for stepping out of the shower, this bundle includes 2 Bath Towels, 2 Hand Towels, and 4 Wash Cloths, all from our Premium Plush Collection.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/classic_bath_bundle.jpg?v=1645775355",
    products: [
      {
        handle: "the-premium-plush-bath-towel",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-hand-towel",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-wash-cloth",
        quantity: 1,
      },
    ],
  },
  {
    name: "Premium Plush Deluxe Bundle",
    description:
      "Turn your bathroom into the sanctuary of your dreams with our fully customizable Premium Plush Deluxe Bundle. Luxurious to the touch, ultra-absorbent, and ideal for stepping out of the shower, this bundle includes 4 Bath Towels, 4 Hand Towels, and 4 Wash Cloths, all from our Premium Plush Collection.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/classic_plus_bath_bundle.jpg?v=1645775427",
    products: [
      {
        handle: "the-premium-plush-bath-towel",
        quantity: 2,
      },
      {
        handle: "the-premium-plush-hand-towel",
        quantity: 2,
      },
      {
        handle: "the-premium-plush-wash-cloth",
        quantity: 1,
      },
    ],
  },
  {
    name: "Premium Plush Complete Bundle",
    description:
      "Turn your bathroom into the sanctuary of your dreams with our fully customizable Premium Plush Complete Bundle. Luxurious to the touch, ultra-absorbent, and ideal for stepping out of the shower, this bundle includes 2 Bath Towels, 2 Bath Sheets, 2 Hand Towels, 4 Wash Cloths, and 1 Bath Mat, all from our Premium Plush Collection.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/super_bath_bundle.jpg?v=1645775355",
    products: [
      {
        handle: "the-premium-plush-bath-towel",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-bath-sheet",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-hand-towel",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-wash-cloth",
        quantity: 1,
      },
      {
        handle: "the-premium-plush-bath-mat",
        quantity: 1,
      },
    ],
  },
  {
    name: "Classic Bedding Bundle",
    description: `
			Includes the bamboo sheet set,
			1 duvet cover, 
			and 2 extra pillow cases`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/classic_bedding_bundle.jpg?v=1648830757",
    products: [
      {
        handle: "bamboo-sheet-set",
        quantity: 1,
      },
      {
        handle: "bamboo-duvet-cover",
        quantity: 1,
      },
      {
        handle: "pillow-case-set",
        quantity: 1,
      },
    ],
  },
  {
    name: "Deluxe Bedding Bundle",
    description: `
			Includes the bamboo sheet set,
			1 bamboo comforter,
			1 duvet cover,
			and 2 extra pillow cases`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/deluxe_bedding_bundle.jpg?v=1648830911",
    products: [
      {
        handle: "bamboo-duvet-cover",
        quantity: 1,
      },
      {
        handle: "bamboo-sheet-set",
        quantity: 1,
      },
      {
        handle: "comforter",
        quantity: 1,
      },
      {
        handle: "pillow-case-set",
        quantity: 1,
      },
    ],
  },
  {
    name: "Ultimate Bedding Bundle",
    description: `
			Includes the bamboo sheet set,
			1 bamboo comforter,
			1 duvet cover,
			2 silk pillows,
			and 2 pillow cases`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/ultimate_bedding_bundle.jpg?v=1648830757",
    products: [
      {
        handle: "silk-pillow",
        quantity: 2,
      },
      {
        handle: "bamboo-sheet-set",
        quantity: 1,
      },
      {
        handle: "comforter",
        quantity: 1,
      },
      {
        handle: "bamboo-duvet-cover",
        quantity: 1,
      },
      {
        handle: "pillow-case-set",
        quantity: 1,
      },
    ],
  },
  {
    name: "Oprah’s Favorite Things Bundle",
    description: `
			Includes the bamboo sheet set,
			long bamboo pajamas,
			women’s jogger pants,
			& a pack of socks`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/Oprahs-Favorite-bundle.png?v=1650474868",
    products: [
      {
        handle: "long-sleeve-bamboo-pajama-set",
        quantity: 1,
      },
      {
        handle: "bamboo-sheet-set",
        quantity: 1,
      },
      {
        handle: "cozy-earth-ultra-soft-bamboo-jogger-pant",
        quantity: 1,
      },
      {
        handle: "the-plush-lounge-sock",
        quantity: 1,
      },
    ],
  },
  {
    name: "Women’s Loungewear Bundle",
    description: `
			Includes the bamboo pajamas,
			women’s jogger pants,
			women’s pullover crew`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/Womens-Loungewear-bundle.png?v=1650922495",
    products: [
      {
        handle: "bamboo-pullover-crew-sweatshirt-top",
        quantity: 1,
      },
      {
        handle: "cozy-earth-ultra-soft-bamboo-jogger-pant",
        quantity: 1,
      },
      {
        handle: "long-sleeve-bamboo-pajama-set",
        quantity: 1,
      },
    ],
  },
  {
    name: "Men’s Loungewear Bundle",
    description: `
			Men’s Bamboo Jogger Pants,
			Men’s Lounge Tee,
			Men’s Bamboo Hoodie`,
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/Mens-Loungewear-bundle.png?v=1650922495",
    products: [
      {
        handle: "mens-ultra-soft-bamboo-hoodie",
        quantity: 1,
      },
      {
        handle: "ultra-soft-bamboo-jogger-pant",
        quantity: 1,
      },
      {
        handle: "mens-ultra-soft-bamboo-lounge-tee",
        quantity: 1,
      },
    ],
  },
  {
    name: "Rib-Knit Collection Bundle",
    description: `
			Includes the womens rib knit bamboo lounge pant,
			the womens rib knit bamboo long sleeve lounge top, &
			the womens rib knit bamboo v neck tank lounge dress`,
    products: [
      {
        handle: "rib-knit-bamboo-long-sleeve-lounge-top",
        quantity: 1,
      },
      {
        handle: "rib-knit-bamboo-lounge-pant",
        quantity: 1,
      },
      {
        handle: "rib-knit-bamboo-vneck-tank-lounge-dress",
        quantity: 1,
      },
    ],
  },

  {
    name: "Mom-to-Be Bundle",
    description: `
			Includes bamboo crib sheet,
			bamboo baby blanket,
			and women’s bamboo pajamas`,
    products: [
      {
        handle: "crib-sheet",
        quantity: 1,
      },
      {
        handle: "baby-blanket",
        quantity: 1,
      },
      {
        handle: "long-sleeve-bamboo-pajama-set",
        quantity: 1,
      },
    ],
  },
  {
    name: "Waterline Square Bundle",
    description:
      "Turn your NYC residence into the modern sanctuary of your dreams with our fully customizable Waterline Square Bundle. Feel the difference with our best-selling Bamboo Bedding and Premium Plush Bath Collection. This bundle includes a Bamboo Sheet Set, 1 Bamboo or Silk Comforter, 1 Duvet Cover,  2 Plush Bath Towels, 2 Plush Hand Towels, and 1 Bath Mat.",
    image: "https://cdn.shopify.com/s/files/1/2114/3697/files/waterline-bundle-image-1.jpg?v=1686852200",
    products: [
      {
        handle: "bamboo-sheet-set",
        quantity: 1,
      },

      {
        handle: "comforter",
        quantity: 1,
      },

      {
        handle: "bamboo-duvet-cover",
        quantity: 1,
      },

      {
        handle: "the-premium-plush-bath-towel",
        quantity: 1,
      },

      {
        handle: "the-premium-plush-hand-towel",
        quantity: 1,
      },

      {
        handle: "the-premium-plush-bath-mat",
        quantity: 1,
      },
    ],
  },
];
